export const contactMessagesData = [
  {

    id: "CM482902",
    name: "teressa",
    phone: "+601 82392 37359",
    email: "teresa@example.com",
    message: "Reminder: Staff meeting tomorrow.",
    img : "assets/img/teachers/teacher-01.jpg",
    date: "25 Mar 2025",
  },
  {

    id: "CM482901",
    name: "Hellana",
    phone: "+601 23566 52683",
    email: "hellena@example.com",
    message: "Sure, let's discuss it in class.",
    img : "assets/img/teachers/teacher-03.jpg",
    date: "14 Mar 2025",
  },
  {

    id: "CM482900",
    name: "William",
    phone: "+601 63792 50310",
    email: "william@example.com",
    message: "Requesting a meeting for next week.",
    img : "assets/img/users/user-01.jpg",
    date: "28 Mar 2025",
  },
  {

    id: "CM482899",
    name: "Daniel",
    phone: "+601 56752 86742",
    email: "daniel@example.com",
    message: "Meeting scheduled for Jane 10th.",
    img : "assets/img/teachers/teacher-02.jpg",
    date: "04 Mar 2025",
  },
  {

    id: "CM482898",
    name: "Galina",
    phone: "+601 91304 34834",
    email: "galina@example.com",
    message: "Reminder: Staff meeting tomorrow.",
    img : "assets/img/members/members-02.jpg",
    date: "17 Mar 2025",
  },
  {

    id: "CM482897",
    name: "Edward",
    phone: "+601 56187 87489",
    email: "edward@example.com",
    message: "Don't forget to submit the slip.",
    img : "assets/img/teachers/teacher-10.jpg",
    date: "20 Mar 2025",
  },
  {

    id: "CM482896",
    name: "Galina",
    phone: "+601 77502 54845",
    email: "jacquelin@example.com",
    message: "Can we review the test tomorrow?",
    img : "assets/img/members/members-07.jpg",
    date: "03 Jan 2025",
  },
  {

    id: "CM482895",
    name: "Garly",
    phone: "+601 82239 42492",
    email: "gary@example.com",
    message: "Is there a summer camp program?",
    img : "assets/img/users/user-09.jpg",
    date: "15 Jan 2025",
  },
  {

    id: "CM482894",
    name: "Morgan",
    phone: "+601 63204 35730",
    email: "morgan@example.com",
    message: "Yes, registration starts next week.",
    img : "assets/img/teachers/teacher-06.jpg",
    date: "27 Jan 2025",
  },
  {

    id: "CM482893",
    name: "AAron",
    phone: "+601 26267 80542",
    email: "aaron@example.com",
    message: "You have a missing assignment.",
    img : "assets/img/teachers/teacher-06.jpg",
    date: "10 Jan 2025",
  }
]

